export class Contact {
    noIntervenant : string;
    dateNaissance : Date;
    email : string;
     noContact  : string;
     noFax : string;
     noGSM : string;
     noTelephoneBureau : string; 
     noTelephonePrive  : string;
     nom : string;
     prenom : string;
     qualiteCivile : string;
     regimeLinguistique  : string;
     texteLibre : string;
     titre : string;
     LanguageClient : string;
}
